import React, { useState } from "react";
import jsonExport from "jsonexport/dist";
import { fillDownRows } from "../../../utils/exportsUtils";

import DateFnsUtils from "@date-io/date-fns";
import { addMonths, format, startOfMonth } from "date-fns";

import { API, graphqlOperation } from "aws-amplify";
import {
  getOutboundShipmentActivity,
  searchInventorysActivity,
} from "../../../graphql/report-queries";

import { Box, Card, Grid, TextField as FilterField } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {
  Button,
  Datagrid,
  DateField,
  downloadCSV,
  ListContextProvider,
  NumberField,
  SimpleForm,
  TextField,
  Title,
  TopToolbar,
  useList,
  useListContext,
  useNotify,
} from "react-admin";

import { ExportIcon } from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { HelpButton } from "../../../components/common/HelpButton";
import { logError } from "../../../utils/appUtils";
import { InventoryTimelineCard } from "../../../crewApp/pages/inventorySearch/timeline/InventoryTimeline";
import { ShipmentLineItemStatus } from "../../../utils/constants";

const exporter = (inventories, searchTerm) => {
  debugger;
  const inventoriesForExport = inventories.map((inventory) => {
    let totalOutbound = 0;

    const inventoryForExport = {
      inventoryId: inventory.id,
      productCode: inventory.productCode,
      productName: inventory.productName,
      lotNumber: inventory.lotNumber,
      inboundShipmentId: inventory.inboundShipmentId,
      inboundPoNumber: inventory.poNumber,
      receivedAt: inventory.receivedAt,
      inventoryUOM: inventory.inventoryUOM,
      status: inventory.status,
      quantityReceived: `${inventory.quantityReceived}`,
      quantityCommitted: `${inventory.quantityCommitted}`,
      quantityOnHand: `${inventory.quantityOnHand}`,
    };

    if (inventory.shipmentLineItems?.items.length > 0) {
      inventoryForExport.outbounds = inventory.shipmentLineItems?.items.map(
        (itm) => {
          const outbound = {
            quantityShipped: `${itm.totalQuantityToPick}`,
            ShipmentId: itm.outboundShipmentId,
            poNumber: itm.outboundShipment.poNumber,
            status: itm.status,
            shippedDateTime: itm.outboundShipment.departureDateTime,
          };
          totalOutbound +=
            itm.status === ShipmentLineItemStatus.SHIPPED
              ? itm.totalQuantityToPick
              : 0;
          return outbound;
        },
      );
    }

    inventoryForExport.totalQuantityOutbound = `${totalOutbound}`;
    totalOutbound = 0;

    return inventoryForExport;
  });

  jsonExport(
    fillDownRows(inventoriesForExport),
    {
      rename: [
        // "Customer", "Product Code", "Product", "Inventory Qty", "UOM"
      ],
    },
    (err, csv) => {
      downloadCSV(csv, `${searchTerm}`); // download as 'searchTerm.csv` file
    },
  );
};

const ListActions = (props) => {
  const {
    finalData,
    setAccountId,
    yearMonth,
    setYearMonth,
    searchTerm,
    setSearchTerm,
    getInventoryActivity,
  } = props;

  return (
    <Box mt={-4}>
      <TopToolbar>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} md={3}>
              <AccountDropDown
                source="accountId"
                label="Account"
                onAccountChange={(value) => setAccountId(value?.id)}
                allowEmpty={false}
                helperText={false}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <FilterField
                id="search"
                label="Product Name / Code"
                variant="outlined"
                margin="dense"
                fullWidth
                alwaysOn
                value={searchTerm}
                onChange={(evt) => setSearchTerm(evt?.target?.value)}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <DatePicker
                label="Year / Month"
                variant="inline"
                inputVariant="outlined"
                margin="dense"
                fullWidth
                disableToolbar
                disableFuture
                autoOk
                required
                views={["year", "month"]}
                openTo="year"
                format="MM/yyyy"
                minDate={new Date(window.appUser?.reloadYard.createdAt)}
                maxDate={new Date()}
                maxDateMessage="Max. 1 month range."
                value={yearMonth}
                onChange={setYearMonth}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                label="Run"
                variant="contained"
                color="default"
                alwaysOn
                onClick={getInventoryActivity}
                disabled={!yearMonth}
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
        <HelpButton />
        <Button
          label="Export"
          disabled={finalData?.length === 0}
          onClick={() => exporter(finalData, searchTerm)}
        >
          <ExportIcon />
        </Button>
        <BackButton basePath="/reports" />
      </TopToolbar>
    </Box>
  );
};

// /reportInventoryActivity
export const InventoryActivityReport = (props) => {
  const notify = useNotify();
  const reloadYardId = window.appUser?.reloadYardId
    ? window.appUser.reloadYardId
    : props.history?.location?.state?.reloadYardId;

  const [accountId, setAccountId] = useState("");
  const [yearMonth, setYearMonth] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [finalData, setFinalData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInventoryActivity = async () => {
    try {
      setLoading(true);
      debugger;
      const startDate = format(startOfMonth(yearMonth), "yyyy-MM");
      const endDate = format(startOfMonth(addMonths(yearMonth, 1)), "yyyy-MM");
      const limit = 1000;

      const searchInput = {
        sort: { field: "receivedAt", direction: "asc" },
        filter: {
          reloadYardId: { eq: reloadYardId },
          and: [
            { receivedAt: { gte: `${startDate}` } },
            { receivedAt: { lte: `${endDate}` } },
          ],
        },
        limit,
      };
      if (accountId) {
        searchInput.filter.accountId = { eq: `${accountId}` };
      }
      if (searchTerm) {
        searchInput.filter.or = [
          { productCode: { matchPhrasePrefix: `${searchTerm}` } },
          { productCode: { wildcard: `*${searchTerm}*` } },
          { productName: { matchPhrasePrefix: `${searchTerm}` } },
          { productName: { wildcard: `*${searchTerm}*` } },
          { customFields: { matchPhrasePrefix: `${searchTerm}` } },
          { customFields: { wildcard: `*${searchTerm}*` } },
        ];
      }

      let inventorys = [];
      let nextToken = true;
      while (nextToken) {
        const input =
          nextToken === true ? searchInput : { ...searchInput, nextToken };
        const result = await API.graphql(
          graphqlOperation(searchInventorysActivity, input),
        );
        inventorys.splice(-1, 0, ...result.data.searchInventorys.items);
        if (result.data.searchInventorys.items.length < limit) break;
        nextToken = result.data.searchInventorys.nextToken;
      }
      // inventorys = inventorys.filter(itm => itm.shipmentLineItems.items.length > 0 );

      const outboundIdMap = {};
      const promiseList = [];
      inventorys.forEach((inv) => {
        inv.shipmentLineItems.items.forEach((itm) => {
          if (!outboundIdMap[itm.outboundShipmentId]) {
            outboundIdMap[itm.outboundShipmentId] = true;
            promiseList.push(
              API.graphql(
                graphqlOperation(getOutboundShipmentActivity, {
                  id: itm.outboundShipmentId,
                }),
              ),
            );
          }
        });
      });

      const results = await Promise.all(promiseList);
      results.forEach((res) => {
        outboundIdMap[res.data.getOutboundShipment.id] =
          res.data.getOutboundShipment;
      });

      inventorys.forEach((inv) => {
        inv.shipmentLineItems.items.forEach((itm) => {
          itm.outboundShipment = outboundIdMap[itm.outboundShipmentId];
        });
      });

      setFinalData(inventorys);
    } catch (err) {
      logError("InventoryActivityList:getInventoryActivity", err, notify);
      setFinalData([]);
    } finally {
      setLoading(false);
    }
  };

  const fixedFilter = ""; // {"lowInventoryAlert": true};
  const defaultSort = { field: "receivedAt", order: "ASC" };
  const defaultPerPage = 25;

  const listContext = useList({
    ...props,
    data: finalData,
    ids: finalData.map(({ id }) => id),
    loading,
    loaded: !loading,
    filter: fixedFilter,
    sort: defaultSort,
    perPage: defaultPerPage,
  });

  return (
    <SimpleForm toolbar={false}>
      <ListContextProvider value={listContext}>
        <Title title={<ForceTitle title="Inventory Activity" />} />
        <ListActions
          {...props}
          finalData={finalData}
          setAccountId={setAccountId}
          yearMonth={yearMonth}
          setYearMonth={setYearMonth}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          getInventoryActivity={getInventoryActivity}
        />
        <Card>
          <InventoryGrid />
          <Pagination {...listContext} />
        </Card>
      </ListContextProvider>
    </SimpleForm>
  );
};

const InventoryGrid = (props) => {
  const listContext = useListContext(props);
  listContext.basePath = "/inventories";
  listContext.resource = "inventories";
  // const redirectToTimeline = inventoryId => redirect(`/search/timeline/${inventoryId}`)

  return (
    // <Datagrid rowClick={redirectToTimeline} >
    <Datagrid rowClick="expand" expand={<InventoryPeak />} {...listContext}>
      <TextField source="productCode" label="Product Code" />
      <TextField source="productName" label="Product Name" />
      <TextField source="poNumber" label="PO Number" />
      <DateField source="receivedAt" label="Received" />
      <NumberField source="quantityReceived" label="Qty. Received" />
      <NumberField source="quantityOnHand" label="Qty. OnHand" />
      <NumberField source="quantityCommitted" label="Qty. Committed" />
      <TextField source="inventoryUOM" label="UOM" />
    </Datagrid>
  );
};

const InventoryPeak = ({ record, ...props }) => (
  <InventoryTimelineCard inventoryId={record.id} isLoaded={false} />
);
